import loading from '@/images/loader.json';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import { Typography } from '@mui/material';

const LoadingContainer = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    backdrop-filter: blur(16px);
`;

const Title = styled(Typography)`
    margin-bottom: 8px;
    margin-top: 32px;
`;

const SubTitle = styled(Typography)`
    color: ${({ theme }) => theme.colors.black[600]};
`;

const LoadingAnimation = styled(Player)`
    height: 50px;
    width: 50px;
`;

function TranslationDraftLoading() {
    return (
        <LoadingContainer>
            <LoadingAnimation src={loading} autoplay loop />
            <Title variant="h1">Transcribing your video.</Title>
            <SubTitle variant="h1">This won't take long.</SubTitle>
        </LoadingContainer>
    );
}

export default TranslationDraftLoading;
